import React, {useState, useEffect} from 'react';
import {
    Container,
    Button,
    Menu,
    Grid,
    GridColumn,
    List,
    ListItem,
    Image,
    Icon,
    Header,
    Dropdown,
    MenuItem,
    Sidebar,
} from 'semantic-ui-react'

import withRouter from "../common/withRouter";
import {getLanguage} from "../slices/adapt";
import {useDispatch, useSelector} from "react-redux";
import {Link} from 'react-router-dom'


const ClinicianForm = (props) => {
    const dispatch = useDispatch();
    const [translate, setTranslate] = useState("en")
    const [visible, setVisible] = useState(false);
    const [open, setOpen] = useState(false)
    const {language} = useSelector((state) => ({
        language: state.adapt.language,
    }));


    useEffect(() => {
        const params = new URLSearchParams(props.router.location.search);
        const translate = params.get("translate")
        setTranslate(translate || "en")
        dispatch(getLanguage())
    }, [dispatch])


    const [width, setWidth] = useState(window.innerWidth);

    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
        setVisible(isMobile ? visible : false)
    }

    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);

    function isMobileDevice() {
        const regex = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
        return regex.test(navigator.userAgent);
    }

    const isMobile = width <= 768

    let imageWidth = (width + (isMobile ? 100 : -50)) / 4

    imageWidth = imageWidth > 270 ? 270 : imageWidth

    if (isMobileDevice()) {
        console.log("Mobile device detected");
    } else {
        console.log("Desktop device detected");
    }
    let i18n = (language && language.data && language.data.languages && language.data.languages[translate].value) || {}
    return (
        <React.Fragment>
            <Menu fixed='top' inverted
                  style={{background: "linear-gradient(90deg, rgba(11,89,223,1) 0%, rgba(24,122,229,1) 49%, rgba(68,225,249,1) 100%)"}}>
            </Menu>
            <Container style={{marginTop: 40, alignContent: "center"}}>
                <Grid doubling columns={2}
                      style={{alignContent: "right", marginTop:0}}>

                    <GridColumn floated='right' width={8} style={{
                        padding: 0,
                        alignContent: "center",
                        textAlign: isMobile ? "center" : "right",
                    }}>

                        <Button
                            aria-label={i18n.clinician_form_button}
                            className={'menu_button'}
                            icon
                            labelPosition='left'
                            onClick={() => {
                                window.open(window.CONFIG.clinicianURL + "?translate=" + translate, "_self")
                            }}>
                            <Icon name='list alternate' size={"large"}/>
                            {i18n.clinician_form_button}</Button>
                        <Button.Group className={"language"}>
                            <Button
                                aria-label={"Select Language"}
                                icon
                                labelPosition='left'
                                className={'language_button_active'}
                                onBlur={() => setTimeout(() => {
                                    setOpen(false)
                                }, 200)}
                                onClick={() => setOpen(!open)}>
                                <Icon name='world' size={"large"}/>
                                {translate === "en" ? "English" : 'Español'}</Button>
                            <Dropdown
                                open={open}
                                style={{marginLeft: 1}}
                                aria-label={"Select Language"}
                                className='button icon'
                                onBlur={() => setOpen(false)}
                                onClick={() => setOpen(!open)}
                            ><Dropdown.Menu>
                                {translate === "es" &&
                                    <Dropdown.Item
                                        aria-label={"Inglés"}
                                        as={Button}
                                        className={translate === "en" ? 'language_button_active' : "language_button"}
                                        onClick={() => {
                                            setTranslate("en")
                                        }}>Inglés
                                    </Dropdown.Item>
                                }
                                {translate === "en" &&
                                    <Dropdown.Item
                                        aria-label={"Spanish"}
                                        as={Button}
                                        className={translate === "es" ? 'language_button_active' : "language_button"}
                                        onClick={() => {
                                            setTranslate("es")
                                        }}>Spanish
                                    </Dropdown.Item>
                                }
                            </Dropdown.Menu>
                            </Dropdown>
                        </Button.Group>
                    </GridColumn>
                </Grid>
            </Container>
            <Container style={{marginTop: 20, alignContent: "center"}}>
                <Grid columns={2}
                      style={{padding: 20, alignContent: "center"}}>
                    <GridColumn width={1} style={{
                        padding: 0,
                        paddingTop: 15,
                        textAlign: isMobile ? "center" : "initial"
                    }}>
                        <Link to={"/?translate=" + translate}>
                            <Header as={'h4'} style={{cursor: "pointer"}}>
                                <span style={{color: "#0959DF"}}>ADAPT4</span>Change
                            </Header>
                        </Link>
                    </GridColumn>
                    <GridColumn floated='right'
                                width={isMobile ? 1 : 11} style={{
                        padding: 0,
                        paddingTop: 5,
                        alignContent: "center",
                        textAlign: isMobile ? "center" : "right",
                    }}>

                        {isMobile ? <>

                            <Icon name={visible ? "times" : "bars"}
                                  size='large'
                                  checked={visible}
                                  onClick={() => setVisible(!visible)}/>

                        </> : null}
                        {isMobile ? null :
                            <Menu secondary floated='right'>

                                <Link to={"/resources?translate=" + translate}>
                                    <MenuItem
                                        content={i18n.resource_menu || "Resources"}
                                    />
                                </Link>
                                <Link to={"/about?translate=" + translate}>
                                    <MenuItem
                                        content={i18n.about_us_menu || 'About Us'}
                                    />
                                </Link>
                                <Link to={"/becomearesource?translate=" + translate}>
                                    <MenuItem
                                        content={i18n.become_resource_menu || 'Become a Resource'}
                                    />
                                </Link>
                            </Menu>}

                    </GridColumn>
                </Grid>
            </Container>
            <Sidebar.Pushable style={{border: "none"}}>
                <Sidebar
                    inverted
                    as={Menu}
                    animation='overlay'
                    direction='top'
                    vertical
                    onHide={() => setVisible(false)}
                    visible={visible}
                >
                    <Link to={"/resources?translate=" + translate}>
                        <MenuItem
                            content={i18n.resource_menu || "Resources"}
                        />
                    </Link>
                    <Link to={"/about?translate=" + translate}>
                        <MenuItem
                            content={i18n.about_us_menu || 'About Us'}
                        />
                    </Link>
                    <Link to={"/becomearesource?translate=" + translate}>
                        <MenuItem
                            content={i18n.become_resource_menu || 'Become a Resource'}
                        />
                    </Link>
                </Sidebar>
                <Sidebar.Pusher dimmed={visible}>
                    <Menu inverted
                          style={{backgroundColor: "#1E3766", paddingBottom: 50, paddingTop: 50}}>
                        <Container style={{display: "flex", flexDirection: "column"}}>
                            <div style={{display: "flex", flexDirection: "row", marginBottom: 0}}>
                                <Image className={"image-shadow"} src={process.env.PUBLIC_URL + '/image1.png'}
                                       style={{
                                           width: imageWidth, transform: "rotate(-10deg)",
                                           height: imageWidth,
                                           objectFit: 'cover',
                                           marginLeft: isMobile ? 5 : 50
                                       }}/>
                                <Image className={"image-shadow"} src={process.env.PUBLIC_URL + '/image2.png'}
                                       style={{
                                           width: imageWidth, transform: "rotate(5deg)",
                                           height: imageWidth,
                                           objectFit: 'cover',
                                           marginLeft: -15,
                                           marginTop: 15
                                       }}/>
                                <Image className={"image-shadow"} src={process.env.PUBLIC_URL + '/image3.png'}
                                       style={{
                                           width: imageWidth, transform: "rotate(-5deg)",
                                           height: imageWidth,
                                           objectFit: 'cover',
                                           marginLeft: -40
                                       }}/>
                                <Image className={"image-shadow"} src={process.env.PUBLIC_URL + '/image4.png'}
                                       style={{
                                           width: imageWidth, transform: "rotate(10deg)",
                                           height: imageWidth,
                                           objectFit: 'cover',
                                           marginLeft: -30,
                                           marginTop: 35
                                       }}/>
                            </div>
                            <Header as={'h4'} style={{
                                textAlign: "center",
                                color: "white",
                                letterSpacing: 2.5,
                                fontFamily: "Rockwell",
                                fontWeight: 400,
                                fontSize: isMobile ? 28 : 40
                            }}>
                                {i18n.gallery_caption}
                            </Header>
                        </Container>
                    </Menu>
                    <Container>
                        <div style={{
                            marginBottom: '3em',
                            // marginLeft: '3vw',
                            // marginRight: "3vw",
                            borderRadius: 20,
                            padding: isMobile ? 1 : 10,
                            backgroundColor: "white"
                        }}>
                            <span>{i18n.introduction_message}</span>
                            <br/>
                            <br/>
                            <br/>
                            <div
                                style={{
                                    whiteSpace: "pre-wrap",
                                    fontSize: 16,
                                    textAlign: "center"
                                }}>
                                <Grid doubling columns={2}>
                                    <GridColumn width={8} style={{alignContent: "center"}}>
                                        <iframe title={"https://www.youtube.com/embed/rdJAYzE01eI"}
                                                style={{
                                                    alignContent: "center",
                                                    width: "100%",
                                                    height: "100%",
                                                    minHeight: 230
                                                }}
                                                src={"https://www.youtube.com/embed/rdJAYzE01eI"}>
                                        </iframe>

                                    </GridColumn>
                                    <GridColumn width={8} style={{alignContent: "center"}}>
                                        {
                                            i18n.suboxone &&
                                            <div
                                                style={{
                                                    whiteSpace: "pre-wrap",
                                                    fontSize: 16,
                                                    textAlign: "left"
                                                }}>

                                                <Header as={'h4'}
                                                        style={{
                                                            textAlign: isMobile ? "center" : "left",
                                                            color: "#053b99"
                                                        }}>
                                                    {i18n.suboxone.header}
                                                </Header>
                                                <span>{i18n.suboxone.content}</span>
                                                <List as='ul' className={"dashed"}>
                                                    {i18n.suboxone.list.map(item => {
                                                        return <ListItem as='li'><span>{item}</span></ListItem>
                                                    })}
                                                </List>
                                            </div>
                                        }
                                    </GridColumn>
                                </Grid>
                            </div>
                        </div>
                        <div style={{
                            marginBottom: '3em',
                            // marginLeft: '3vw',
                            // marginRight: "3vw",
                            borderRadius: 20,
                            padding: isMobile ? 1 : 10,
                            backgroundColor: "white"
                        }}>
                            <div
                                style={{
                                    whiteSpace: "pre-wrap",
                                    fontSize: 16,
                                    textAlign: "center"
                                }}>
                                <Grid doubling columns={2}>
                                    <GridColumn width={8} style={{alignContent: "center"}}>
                                        {i18n.resource && <div
                                            style={{
                                                whiteSpace: "pre-wrap",
                                                fontSize: 16,
                                                textAlign: "left"
                                            }}>
                                            <Header as={'h4'} style={{textAlign: "center", color: "#0A8453"}}>
                                                <Grid doubling={isMobile} columns={2} centered>
                                                    <GridColumn width={3}
                                                                style={{
                                                                    alignContent: "center",
                                                                    textAlign: isMobile ? "center" : "right"
                                                                }}>
                                                        <Image src={process.env.PUBLIC_URL + '/home.png'} style={{
                                                            width: 60,
                                                            height: 55,
                                                            marginLeft: isMobile ? "auto" : "none",
                                                            marginRight: isMobile ? "auto" : "none",
                                                            border: "1px solid #0A8453",
                                                            borderRadius: 15,
                                                            backgroundColor: "white",
                                                            padding: "5px 5px"
                                                        }}/>
                                                    </GridColumn>
                                                    <GridColumn width={12}
                                                                style={{
                                                                    alignContent: isMobile ? "center" : "left",
                                                                    textAlign: isMobile ? "center" : "left"
                                                                }}>
                                                        {i18n.resource.header}
                                                    </GridColumn>
                                                </Grid>
                                            </Header>
                                            <span>{i18n.resource.content}</span>
                                            <br/>
                                            <br/>
                                            <div className={"button_wrapper"}>
                                                <Link to={"/resources?translate=" + translate}>
                                                    <Button
                                                        fluid
                                                        className={"resource_button"}
                                                    >{i18n.resource.button_text}</Button>
                                                </Link></div>
                                        </div>
                                        }
                                    </GridColumn>
                                    <GridColumn width={8}>
                                        <Image src={process.env.PUBLIC_URL + '/image5.png'}/>
                                    </GridColumn>

                                </Grid>
                            </div>
                        </div>
                        <hr/>
                        {i18n.safer_use &&
                            <div style={{
                                // marginLeft: '3vw',
                                // marginRight: "3vw",
                                borderRadius: 20,
                                padding: isMobile ? 1 : 10,
                                backgroundColor: "white"
                            }}>
                                <Header as={'h4'} style={{textAlign: "center", color: "#580272"}}>
                                    <Grid doubling={isMobile} columns={2} centered>
                                        <GridColumn width={6} style={{
                                            alignContent: "center",
                                            textAlign: isMobile ? "center" : "right"
                                        }}>
                                            <Image src={process.env.PUBLIC_URL + '/cross.png'} style={{
                                                width: 60,
                                                height: 55,
                                                marginLeft: "auto",
                                                marginRight: isMobile ? "auto" : "0",
                                                border: "1px solid #691A81",
                                                borderRadius: 10,
                                                backgroundColor: "white",
                                                padding: "5px 5px"
                                            }}/>
                                        </GridColumn>
                                        <GridColumn width={10} style={{
                                            alignContent: "center",
                                            textAlign: isMobile ? "center" : "left"
                                        }}>
                                            {i18n.safer_use.header}
                                        </GridColumn>
                                    </Grid>
                                </Header>
                                <span
                                    dangerouslySetInnerHTML={{__html: i18n.safer_use.content}}></span>
                                <br/>
                                <br/>
                                <div
                                    style={{
                                        marginTop: 20,
                                        marginBottom: 10,
                                        whiteSpace: "pre-wrap",
                                        fontSize: 16,
                                        textAlign: "center"
                                    }}>
                                    <Grid doubling columns={2}>
                                        <GridColumn width={8} style={{padding: 0}}>
                                            <List as='ul'>
                                                {i18n.safer_use.list_1.map(item => {
                                                    return <ListItem as='div' style={{marginBottom: 20}}><p
                                                        style={{textAlign: "left"}}>
                                            <span
                                                dangerouslySetInnerHTML={{__html: item}}></span>
                                                    </p>
                                                    </ListItem>
                                                })}
                                            </List>
                                        </GridColumn>
                                        <GridColumn width={8} style={{padding: 0}}>
                                            <List as='ul'>
                                                {i18n.safer_use.list_2.map(item => {
                                                    return <ListItem as='div' style={{marginBottom: 20}}><p
                                                        style={{textAlign: "left"}}>
                                            <span
                                                dangerouslySetInnerHTML={{__html: item}}></span>
                                                    </p>
                                                    </ListItem>
                                                })}
                                            </List>
                                        </GridColumn>

                                    </Grid>
                                </div>
                                <br/>
                                <div style={{textAlign: "center", marginBottom: 50}}>
                        <span
                            dangerouslySetInnerHTML={{__html: i18n.safer_use.more}}></span>
                                    <br/>
                                    <span
                                        dangerouslySetInnerHTML={{__html: i18n.safer_use.footer}}></span>
                                </div>
                            </div>
                        }
                        {i18n.online_resources &&
                            <div style={{
                                marginBottom: '3em',
                                // marginLeft: '3vw',
                                // marginRight: "3vw",
                                borderRadius: 20,
                                padding: isMobile ? 1 : 10,
                                backgroundColor: "white"
                            }}>
                                <Header as={'h4'} style={{textAlign: "center"}}>
                                    <Grid centered>
                                        <GridColumn style={{
                                            alignContent: "center",
                                            textAlign: "center"
                                        }}>
                                            {i18n.online_resources.header}
                                        </GridColumn>
                                    </Grid>
                                </Header>
                                <br/>
                                <div
                                    style={{
                                        marginTop: 20,
                                        marginBottom: 10,
                                        whiteSpace: "pre-wrap",
                                        fontSize: 16,
                                        textAlign: "center"
                                    }}>
                                    <Grid stackable doubling columns={4}>
                                        <GridColumn style={{padding: 0}}>
                                            <List as='ul'>
                                                <ListItem as='div' style={{marginBottom: 20}}><p
                                                    style={{textAlign: "left"}}>
                                                    <Image src={process.env.PUBLIC_URL + '/STASHID.png'} style={{
                                                        marginLeft: "auto",
                                                        marginRight: isMobile ? "auto" : "0",
                                                        border: "1px solid #691A81",
                                                        backgroundColor: "white",
                                                    }}/>
                                                </p>
                                                </ListItem>
                                                <ListItem as='div' style={{marginBottom: 20}}>
                                                    <p style={{textAlign: "left"}}>
                                            <span
                                                dangerouslySetInnerHTML={{__html: i18n.online_resources.stash_caption}}></span>
                                                        <br/>
                                                        <br/>
                                                        <div style={{
                                                            textAlign: "center",
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            justifyContent: "center",
                                                            alignItems: "center",
                                                            margin: 20
                                                        }}>
                                                            <Button fluid
                                                                    className={'view_button'}
                                                                    onClick={() => {
                                                                        window.open("https://stashid.org/", "_blank")
                                                                    }}>
                                                                {i18n.online_resources.view_website}
                                                            </Button>
                                                        </div>
                                                    </p>
                                                </ListItem>
                                            </List>
                                        </GridColumn>
                                        <GridColumn style={{padding: 0}}>
                                            <List as='ul'>
                                                <ListItem as='div' style={{marginBottom: 20}}><p
                                                    style={{textAlign: "left"}}>
                                                    <Image src={process.env.PUBLIC_URL + '/BUP.png'} style={{
                                                        marginLeft: "auto",
                                                        marginRight: isMobile ? "auto" : "0",
                                                        border: "1px solid #691A81",
                                                        backgroundColor: "white",
                                                    }}/>
                                                </p>
                                                </ListItem>
                                                <ListItem as='div' style={{marginBottom: 20}}>
                                                    <p style={{textAlign: "left"}}>
                                             <span
                                                 dangerouslySetInnerHTML={{__html: i18n.online_resources.bup_caption}}></span>
                                                        <br/>
                                                        <br/>
                                                        <div style={{
                                                            textAlign: "center",
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            justifyContent: "center",
                                                            alignItems: "center"
                                                        }}>
                                                            <Image
                                                                src={process.env.PUBLIC_URL + '/downloadappstore.svg'}
                                                                style={{
                                                                    backgroundColor: "white",
                                                                    width: "100%",
                                                                    paddingLeft: 25,
                                                                    paddingRight: 25,
                                                                    paddingBottom: 10,
                                                                    maxWidth: 250,
                                                                }}
                                                                onClick={() => {
                                                                    window.open("https://apps.apple.com/us/app/buprenorphine-home-induction/id1449302173", "_blank")
                                                                }}/>
                                                            <Image
                                                                src={process.env.PUBLIC_URL + '/getitonplaystore.png'}
                                                                style={{
                                                                    backgroundColor: "white",
                                                                    width: "100%",
                                                                    paddingLeft: 25,
                                                                    paddingRight: 25,
                                                                    paddingBottom: 10,
                                                                    maxWidth: 250,

                                                                }}
                                                                onClick={() => {
                                                                    window.open("https://play.google.com/store/apps/details?id=com.amstonstudio.bup", "_blank")
                                                                }}/>
                                                        </div>

                                                    </p>
                                                </ListItem>
                                            </List>
                                        </GridColumn>
                                        <GridColumn style={{padding: 0}}>
                                            <List as='ul'>
                                                <ListItem as='div' style={{marginBottom: 20}}><p
                                                    style={{textAlign: "left"}}>
                                                    <Image src={process.env.PUBLIC_URL + '/SSU.png'} style={{
                                                        marginLeft: "auto",
                                                        marginRight: isMobile ? "auto" : "0",
                                                        border: "1px solid #691A81",
                                                        backgroundColor: "white",
                                                    }}/>
                                                </p>
                                                </ListItem>
                                                <ListItem as='div' style={{marginBottom: 20}}>
                                                    <p style={{textAlign: "left"}}>
                                             <span
                                                 dangerouslySetInnerHTML={{__html: i18n.online_resources.ssu_caption}}></span>
                                                        <br/>
                                                        <br/>
                                                        <div style={{
                                                            textAlign: "center",
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            justifyContent: "center",
                                                            alignItems: "center",
                                                            margin: 20
                                                        }}>
                                                            <Button className={'view_button'}
                                                                    fluid
                                                                    onClick={() => {
                                                                        window.open("https://safersubstanceuse.org/", "_blank")
                                                                    }}>
                                                                {i18n.online_resources.view_website}
                                                            </Button>
                                                        </div>
                                                    </p>
                                                </ListItem>
                                            </List>
                                        </GridColumn>
                                        <GridColumn style={{padding: 0}}>
                                            <List as='ul'>
                                                <ListItem as='div' style={{marginBottom: 20}}><p
                                                    style={{textAlign: "left"}}>
                                                    <Image src={process.env.PUBLIC_URL + '/RP.png'} style={{
                                                        marginLeft: "auto",
                                                        marginRight: isMobile ? "auto" : "0",
                                                        border: "1px solid #691A81",
                                                        backgroundColor: "white",
                                                    }}/>
                                                </p>
                                                </ListItem>
                                                <ListItem as='div' style={{marginBottom: 20}}>
                                                    <p style={{textAlign: "left"}}>
                                             <span
                                                 dangerouslySetInnerHTML={{__html: i18n.online_resources.recoverypad_caption}}></span>
                                                        <br/>
                                                        <br/>

                                                        <div style={{
                                                            textAlign: "center",
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            justifyContent: "center",
                                                            alignItems: "center",
                                                            margin: 20
                                                        }}>
                                                            <Button className={'view_button'}
                                                                    fluid
                                                                    onClick={() => {
                                                                        window.open("https://www.recoverypad.com/", "_blank")
                                                                    }}>
                                                                {i18n.online_resources.view_website}
                                                            </Button>
                                                        </div>
                                                    </p>
                                                </ListItem>

                                            </List>
                                        </GridColumn>
                                    </Grid>
                                </div>
                                <br/>
                            </div>
                        }
                    </Container>
                </Sidebar.Pusher>
            </Sidebar.Pushable>


            <footer>
                <p>
                    <span className={"header"}>{i18n.footer && i18n.footer.header}</span>
                    <br/>
                    <br/>
                    <span className={"subheader"}>{i18n.footer && i18n.footer.content}</span>
                </p>
            </footer>

        </React.Fragment>
    );
};

export default withRouter(ClinicianForm);
